"use client"

import { useTranslate } from "@tolgee/react"
import { VariantMetadataAttributeProps } from "@/types/product"
import { ProductPageAccordion } from "@/components/molecules"
import { StoreProductVariant } from "@medusajs/types"

export const ProductVariantAttributes = ({
    variant,
}: {
    variant: StoreProductVariant | null,
}) => {
    const { t } = useTranslate()
    if (!variant || !variant.metadata) {
        return null
    }

    const displayKeys = ["width", "height", "length", "weight", "mid_code", "hs_code", "origin_country"];
    const metadata = variant.metadata as unknown as VariantMetadataAttributeProps

    return (
        <ProductPageAccordion heading={t("product_additional_attributes.heading")} defaultOpen={true}>
            {Object.entries(metadata)
            .filter(([k,v]) => displayKeys.includes(k) && (v !== null && v !== undefined))
            .map(([attr, val]) => (
                <div
                    key={attr}
                    className="border  rounded-sm flex text-center label-md"
                >
                    <div className="border-r py-3 w-[271px] bg-[#F9FAFB] z-[-1]">{t(`product_additional_attributes.${attr}`)}</div>
                    <div className="py-3 flex-1">{val}</div>
                </div>
            ))}
        </ProductPageAccordion>
    )
}
